// Topbar 2 hàng (UI_SPEC §3.1): Thân · tiêu đề tab · 2 viên tiền tệ · Truyền Âm; hàng sub-tab.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { formatCompact } from '@i18n/format';
import { tabDef } from '@data/screens';
import { TOPBAR_CURRENCIES } from '@data/currencies';
import { activeScreen, activeTab, openSubpage, selectScreen } from '@state/modules/ui';
import { wallet } from '@state/modules/wallet';
import { unreadTotal } from '@state/modules/log';
import { Icon } from '../icons';

export function Topbar(): JSX.Element {
  const tab = activeTab.value;
  const def = tabDef(tab);
  const unread = unreadTotal.value;
  return (
    <header class="shell-topbar" data-id="topbar">
      <div class="tb-row">
        <button
          type="button"
          class="ht-iconbtn"
          data-id="btn-profile"
          aria-label={t('ui.profile')}
          onClick={() => openSubpage('self')}
        >
          <Icon name="character" />
        </button>
        <h1 class="tb-title" data-id="tab-title">
          {t(`ui.tab.${tab}`)}
        </h1>
        {TOPBAR_CURRENCIES.map((c) => (
          <span
            key={c}
            class="tb-pill"
            data-id={`pill-${c}`}
            style={{ '--cur-rgb': `var(--cur-${c}-rgb)` }}
            aria-label={`${t(`currency.${c}`)} ${wallet.value[c]}`}
          >
            <Icon name={c} />
            {formatCompact(wallet.value[c])}
          </span>
        ))}
        <button
          type="button"
          class="ht-iconbtn"
          data-id="btn-transmission"
          aria-label={
            unread > 0
              ? `${t('ui.transmission')}, ${t('ui.transmission.unread', { n: unread })}`
              : t('ui.transmission')
          }
          onClick={() => openSubpage('transmission')}
        >
          <Icon name="transmission" />
          {unread > 0 && <span class="ht-badge">{unread > 99 ? '99+' : unread}</span>}
        </button>
      </div>
      <nav
        class={def.screens.length >= 5 ? 'tb-subtabs five' : 'tb-subtabs'}
        role="tablist"
        aria-label={t(`ui.tab.${tab}`)}
      >
        {def.screens.map((s) => (
          <button
            key={s.id}
            type="button"
            role="tab"
            class="tb-subtab"
            data-id={`subtab-${s.id}`}
            aria-selected={activeScreen.value === s.id}
            onClick={() => selectScreen(s.id)}
          >
            {t(`ui.screen.${tab}.${s.id}`)}
          </button>
        ))}
      </nav>
      <div class="tb-rule" />
    </header>
  );
}
